import type { AssetId } from "@storytell/types";
import { lifecycleStateGrouped } from "~/components/utils/lifecycleStateMappers";
import { useWire } from "~/wire";

export const useGateActionByAsssetsProcessing = <T extends unknown[], U>(action: (...args: T) => U) => {
  const wire = useWire();

  const notReadyAssets = () => {
    const ids = wire.chat.scope.assets();
    const assets = ids.filter((id) => {
      const asset = wire.assets.get(id as AssetId);
      if (!asset) return false;
      return ["processing", "uploading"].includes(lifecycleStateGrouped(asset.status.state));
    });

    return assets;
  };
  const wrappedAction = (...args: T): U | undefined => {
    if (wire.chat.scope.uploadingAssets().length || notReadyAssets().length) {
      wire.ui.processingAssetsGate.openModal(() => action(...args));
      return;
    }
    return action(...args);
  };

  return wrappedAction;
};
